import React, { useEffect, useState } from 'react'
import Layout from '../../layout/Layout'
import { TbLoader3 } from 'react-icons/tb'
import axios from 'axios';
import { Toaster, toast } from 'sonner';

const SuccessAbono = () => {

    const [loading, setLoading] = useState(true);
    const [user, setUser] = useState(null);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const no_operacion = params.get('payment_id');
        const forma_pago = params.get('payment_type');
        const monto_pagado = params.get('total_venta');
        
        const user = localStorage.getItem('eyJhbGciOiJIUzI1NiJ9');
        const factura_abonoMV = sessionStorage.getItem('factura_abonoMV');
        
        if(user && factura_abonoMV){
            const userData = JSON.parse(user);
            setUser(userData);
            const facturaData = JSON.parse(factura_abonoMV);
            
            const requestData = {
                id_usuario: userData.id,
                cliente: userData.cliente,
                no_operacion: no_operacion,
                forma_pago: forma_pago,
                serie_factura: facturaData.serie,
                folio_factura: facturaData.folio,
                documento: facturaData.letra,
                saldo: facturaData.saldo_actual,
                saldo_vencido: facturaData.saldo_vencido,
                intereses: facturaData.intereses,
                monto_pagado: monto_pagado,
                email: userData.email,
                nombre: userData.nombre_completo,
            };
            axios.post('https://muebleria-villarreal.com/apimv/generarAbonoController.php', requestData, {
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(response => {
                if(response.status === 'error'){
                    toast.error(response.message);
                    setLoading(false);
                    sessionStorage.removeItem('factura_abonoMV');
                } else {
                    axios.post('https://muebleria-villarreal.com/apimv/successPagoAbonoMail.php', requestData, {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                    .then(response => {
                        toast.success('Abono realizado correctamente');
                        setLoading(false);
                        sessionStorage.removeItem('factura_abonoMV');
                    })
                    .catch(error => {
                        toast.error('Error al enviar el correo. Intenta nuevamente o contacta al administrador del sistema.');
                        setLoading(false);
                    });
                }
            })
            .catch(error => {
                toast.error('Error al generar el abono. Intenta nuevamente o contacta al administrador del sistema.');
                setLoading(false);
            });
        } else {
            window.location.href = '/cliente';
        }
    }, []);

  return (
    <Layout>
        <section className='w-full h-[80dvh] flex flex-col items-center justify-center relative'>
            {
                loading &&
                <div className='w-full h-[80dvh] bg-white bg-opacity flex justify-center items-center absolute top-0 left-0 z-20'>
                    <TbLoader3 className='stroke-azul animate-spin h-20 w-20' />
                </div>
            }
            <h1 className='text-2xl font-bold text-azul pb-2'>Abono realizado correctamente</h1>
            <p className='text-sm text-gray-700'>Gracias por tu abono, {user?.nombre_completo}</p>
            <p className='text-sm text-gray-700'>Recibiras un correo con los detalles de tu abono a tu correo.</p>
            <div className='flex flex-row items-center justify-center gap-2 pt-5'>
                <a href={`/cliente`} className='bg-azul text-white px-6 py-3 rounded-md'>Ir a mi cuenta</a>
                <a href={`/`} className='bg-azul text-white px-6 py-3 rounded-md'>Volver al inicio</a>
            </div>
        </section>
    </Layout>
  )
}

export default SuccessAbono